import React, { FC, MouseEvent } from "react";
import styled from "styled-components/macro";

export enum EButtonType {
  primary = "primary",
  primaryBlack = "primaryBlack",
  secondary = "secondary"
}
interface IButtonProps {
  text: string;
  onClick: (e: MouseEvent) => void;
  buttonType?: keyof typeof EButtonType;
  buttonWidth?: string;
  className?: string;
}

export const Button: FC<IButtonProps> = props => {
  const { text, buttonType, onClick, buttonWidth, className } = props;

  let ButtonComponent = ButtonBase;

  if (buttonType === EButtonType.primary) ButtonComponent = PrimaryButton;
  if (buttonType === EButtonType.secondary) ButtonComponent = SecondaryButton;

  return (
    <ButtonComponent buttonWidth={buttonWidth} onClick={onClick} className={className}>
      <Text>{text}</Text>
    </ButtonComponent>
  );
};

Button.defaultProps = {
  buttonType: EButtonType.primary
};

const ButtonBase = styled.button<{ buttonWidth?: string }>`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  padding: 0 24px;
  border-width: 0;
  outline: 0;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ buttonWidth }) => buttonWidth && `width: ${buttonWidth}`};

  min-width: 128px;
  max-width: 400px;
  height: 44px;

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const PrimaryButton = styled(ButtonBase)`
  background-color: ${({ theme }) => theme.colors.primary100};

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.grayDark};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.primaryDisabled};
  }
`;

const SecondaryButton = styled(ButtonBase)`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grayDark};
  border: 2px solid;
  border-color: ${({ theme }) => theme.colors.gray30};

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary100};

    * {
      color: ${({ theme }) => theme.colors.primary100};
    }
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.gray20};
  }
`;

const Text = styled.div`
  display: flex;
  align-items: center;
`;
